module.exports = __webpack_public_path__ + "static/media/Group 3.dde9eb45.png";